"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_router_1 = require("react-router");
var LoadingContent_1 = __importDefault(require("components/Spinners/LoadingContent"));
var TenantChoiceModal_1 = __importDefault(require("./TenantChoiceModal"));
var utils_1 = require("./utils");
var OAuthRedirect = function (_a) {
    var match = _a.match, location = _a.location;
    var app = match.params.app;
    var _b = __read((0, utils_1.useCallCallback)(app, location), 2), redirectUrl = _b[0], tenantsSettings = _b[1];
    if (!redirectUrl) {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(LoadingContent_1.default, {}), (0, jsx_runtime_1.jsx)(TenantChoiceModal_1.default, { isOpen: !!tenantsSettings, setTenant: tenantsSettings === null || tenantsSettings === void 0 ? void 0 : tenantsSettings.setTenant, tenants: tenantsSettings === null || tenantsSettings === void 0 ? void 0 : tenantsSettings.tenantsToChose })] }));
    }
    return (0, jsx_runtime_1.jsx)(react_router_1.Redirect, { to: redirectUrl });
};
exports.default = OAuthRedirect;
